import { z } from 'zod';
/** Value must be present and a UUID (required select fields); output is lowercased so text-matching callers see one spelling. */
export const requiredUuidString = (requiredMessage, invalidMessage) => z
    .string({ error: requiredMessage })
    .superRefine((value, context) => {
    if (!value.trim()) {
        context.addIssue({ code: 'custom', message: requiredMessage, path: [] });
        return;
    }
    if (!z.uuid({ version: 'v7' }).safeParse(value).success) {
        context.addIssue({ code: 'custom', message: invalidMessage, path: [] });
    }
})
    .transform((value) => value.toLowerCase());
//# sourceMappingURL=required-uuid-string.js.map